import { useState } from "react";
import { Alert, Box } from "@mui/material";
import ManpowerCostForm from "../../ChatWindow/ManpowerCostForm";
import styles from "./styles.module.css";

interface ManpowerCostFormErrorProps {
  errorMessage?: string;
  parsedContent?: any;
}

export default function ManpowerCostFormError({
  errorMessage = "File invalid, please try again",
  parsedContent,
}: ManpowerCostFormErrorProps): JSX.Element {
  const [showError, setShowError] = useState(true);

  // Extract template URL and error reason from parsed content
  const templateUrl = parsedContent?.finalAnswer?.input_template;
  const errorReason = parsedContent?.finalAnswer?.reason;

  // Use dynamic error reason if available, otherwise fall back to prop or default
  const displayError = errorReason || errorMessage;

  const handleCloseError = () => {
    setShowError(false);
  };

  return (
    <Box className={styles.container}>
      {/* Error Alert */}
      {showError && (
        <Alert severity="error" onClose={handleCloseError} sx={{ mb: 3 }}>
          {displayError}
        </Alert>
      )}

      {/* Show the original form for re-upload */}
      <ManpowerCostForm hideSubtitle templateUrl={templateUrl} />
    </Box>
  );
}
